/**
 * Browser feature-detect helper (task 7.3, Req 11.5 / 11.6)
 *
 * 呼出側 (UI 層) が passkey UI を出すか / password 経路へフォールバックするかを
 * 判断できるよう、実行環境の WebAuthn / Conditional UI サポートを非同期判定する。
 *
 * - `webAuthnSupported`: `window.PublicKeyCredential` の有無 (Req 11.5 フォールバック信号)
 * - `conditionalMediationSupported`: `PublicKeyCredential.isConditionalMediationAvailable()`
 *   の結果 (Req 11.6、`mediation:"conditional"` を試行してよいかの判定)
 *
 * SSR / 非ブラウザ文脈で import されても安全なよう、すべて `typeof window` で guard し、
 * `isConditionalMediationAvailable` が throw した場合も defensive に `false` を返す。
 */
/**
 * 実行環境ブラウザの WebAuthn / Conditional UI サポートを判定する (Req 11.5 / 11.6)。
 *
 * @returns `{ webAuthnSupported, conditionalMediationSupported }`
 */
export async function detectBrowserSupport() {
    const webAuthnSupported = typeof window !== "undefined" && typeof window.PublicKeyCredential !== "undefined";
    if (!webAuthnSupported) {
        return { webAuthnSupported: false, conditionalMediationSupported: false };
    }
    const conditionalMediationSupported = await detectConditionalMediationSupport();
    return { webAuthnSupported, conditionalMediationSupported };
}
/**
 * `PublicKeyCredential.isConditionalMediationAvailable()` を defensive に評価する (Req 11.6)。
 *
 * メソッド未実装 (旧ブラウザ) や呼出が throw した場合は `false` を返す。
 * 呼出側はこの戻り値が false のとき `mediation:"conditional"` を試行してはならない。
 */
export async function detectConditionalMediationSupport() {
    if (typeof window === "undefined" || typeof window.PublicKeyCredential === "undefined") {
        return false;
    }
    const pkc = window.PublicKeyCredential;
    if (typeof pkc.isConditionalMediationAvailable !== "function") {
        return false;
    }
    try {
        return await pkc.isConditionalMediationAvailable();
    }
    catch {
        // 仕様外の throw (一部ブラウザ実装) でも passkey フローを壊さず degrade する。
        return false;
    }
}
//# sourceMappingURL=browser-support.js.map